import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useTodayQuote() {
  return useQuery({
    queryKey: ['quote', 'today'],
    queryFn: () => api.quotes.getToday(),
  });
}

export function useRandomQuote() {
  return useQuery({
    queryKey: ['quote', 'random'],
    queryFn: () => api.quotes.getRandom(),
  });
}

export function useQuote(id: number) {
  return useQuery({
    queryKey: ['quote', id],
    queryFn: () => api.quotes.getById(id),
    enabled: !!id,
  });
}

export function useQuotes(params?: Record<string, string>) {
  return useQuery({
    queryKey: ['quotes', params],
    queryFn: () => api.quotes.getAll(params),
  });
}
